import React from "react";

const CloseButton = ({handleClose}) => {
  return <button type="button" onClick={handleClose} className="btn-close" data-bs-dismiss="modal" aria-label="Close" />;
};

export default CloseButton;
